import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { store } from "./store";
import "dayjs/locale/zh-cn";
import locale from "element-plus/lib/locale/lang/zh-cn";
import ElementPlus from "element-plus";
import "element-plus/lib/theme-chalk/index.css";
import "./assets/css/font.css";
import "./assets/css/index.css";
import { defineComponent } from "vue";

import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";




import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
// import './directive.js'

// import $ from 'jquery'
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/iconfont/iconfont-weapp-icon.css";
function initializeHSPEED() {
  if ((window as any)._hspeed && (window as any)._hspeed.init) {
    (window as any)._hspeed.init('kcqymji7hw', 'gsmgu9wnrb')
  

    // 在这里添加修改 CSS 的代码
    // let  watermark = document.getElementById('custom-watermark');
    // if (watermark) {
    //   watermark.style.position = 'absolute'
    // }

  } else {
    console.error('HSPEED is not available.');
  }
}

// 初始化 HSPEED
initializeHSPEED();
createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus, { locale })

  .component('QuillEditor', QuillEditor,)
  .component('FullCalendar', FullCalendar,)

  .mount("#app");
